'use client'

import { useTranslate } from '@marketplace-web/shared/i18n'

const VideoSection = () => {
  const translate = useTranslate('item_verification.video')

  return (
    <section className="item-verification__video">
      <h2 className="item-verification__video-title">{translate('title')}</h2>
      <p className="item-verification__video-description">{translate('description')}</p>
      <iframe
        src={translate('video_url')}
        title={translate('title')}
        className="item-verification__video-iframe"
        allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        data-testid="hfv-intro_video"
      />
    </section>
  )
}

export default VideoSection
